const isBaseFee = (fee: number, baseFee: number): boolean =>
  fee === 0 && baseFee > 0;
export { isBaseFee };
